import {
	DeleteProcessInstance,
	GetWorkflowListHistoryByAssigneeEndPoint,
	GetTaskVariables,
	cloneWorkflow as cloneWorkflowEndpoint,
	PostregeneratePDF,
	GetFormByUserTaskEndPoint,
	setAssignEndPoint,
	PutProcessInstanceVariableEndPoint,
	GetPendingTasksEndPoint,
	UnclaimTaskEndPoint,
	ClaimTaskEndPoint,
	GetWorkflowsEndpoint,
	StartProcessByDefinitionKeyEndPoint,
	StartProcessEndPoint
} from "common/constants";
import i18next from "i18next";
import { makeAuthenticatedRequest } from "../helpers/authenticatedRequest";
import { getFormByID } from "../api/formsApi"


export const deletePendingTask = async ({ task_id }, signal = null) => {
	const url = `${DeleteProcessInstance}/${task_id}`;

	const response = await makeAuthenticatedRequest(url, {
		method: "DELETE",
		signal,
	});

	return response;
};

export const getWorkflowsList = async (userId, companyId, signal = null) => {
	const url = `${GetWorkflowsEndpoint}?userId=${userId}&companyId=${companyId}`;
	const response = await makeAuthenticatedRequest(url, { signal });
	return response;
};

export const getWorkflowHistories = async (
	assignee,
	selectedCompany,
	enableModifyStatus = false,
	pageNumber = 1,
	recordsByPage = 10,
	searchParam = "",
	startDate = "",
	endDate = "",
	sortField = "modificationDate",
	sortDirection = "desc",
	signal = null // ✅ Add signal parameter with default null
) => {
	var url = `${GetWorkflowListHistoryByAssigneeEndPoint}/${assignee}`;

	const JsonBody = {
		"pageNumber": pageNumber,
		"recordsByPage": recordsByPage,
		"searchParam": searchParam,
		"startDateTime": startDate,
		"endDateTime": endDate,
		"lang": i18next.language,
		"sortField": sortField,
		"sortDirection": sortDirection,
		"platform": null, //need to be removed in future
		"selectedCompany": selectedCompany,
		"enableModifyStatus": enableModifyStatus
	};

	const result = await makeAuthenticatedRequest(url, {
		method: "POST",
		body: JSON.stringify(JsonBody),
		signal, // ✅ Pass signal to fetch (can be null, that's fine)
	});

	return result;
};

export const getTaskVariables = async (processInstanceId, signal = null) => {
	const url = `${GetTaskVariables}/${processInstanceId}`;

	const response = await makeAuthenticatedRequest(url, {
		method: "GET",
		signal,
	});

	return response;
};

export const cloneWorkflow = async (applicationId, assignee, processInstanceId = "", signal = null) => {
	const url = `${cloneWorkflowEndpoint}/${applicationId}/${assignee}/${processInstanceId}`;

	const response = await makeAuthenticatedRequest(url, {
		method: "POST",
		signal,
	});

	return response;
};

export const postRegeneratePDF = async (applicationID, templateId, tableId, signal = null) => {
	const url = `${PostregeneratePDF}/${applicationID}/${templateId}/${tableId}`;
	const response = await makeAuthenticatedRequest(url, { method: "POST", signal });
	return response;
};

export const getFormByUserTask = async (processInstanceId, signal = null) => {
	const url = `${GetFormByUserTaskEndPoint}/${processInstanceId}`;

	const response = await makeAuthenticatedRequest(url, {
		method: "GET",
		signal,
	});

	return response;
};

export const setAssigneeForTask = async (assigneeData, signal = null) => {
	const { taskId, userId, tableName, fieldName, createdId, processId, userInfo, driverInfo, selectedCompany } = assigneeData;
	const jsonData = {
		"userID": userId,
		"databaseSync": {
			"tableName": tableName,
			"fieldName": fieldName,
			"createdId": createdId
		},
		"notification": {
			"processId": processId,
			"loggedInUserFullName": userInfo.loggedInUserFullName,
			"oldDriverFullName": driverInfo.oldDriver.fullName,
			"oldDriverPhoneNumber": driverInfo.oldDriver.phoneNumber,
			"newDriverFullName": driverInfo.newDriver.fullName,
			"newDriverPhoneNumber": driverInfo.newDriver.phoneNumber,
			"selectedCompany": selectedCompany
		}
	}
	const url = `${setAssignEndPoint}/${taskId}`;

	const response = await makeAuthenticatedRequest(url,
		{
			method: "POST",
			body: JSON.stringify(jsonData),
			signal,
		}
	);

	return response;
};

export const putProcessInstanceVariable = async (processInstanceId, variableName, jsonData, signal = null) => {
	const url = `${PutProcessInstanceVariableEndPoint}/${processInstanceId}/${variableName}`;

	const response = await makeAuthenticatedRequest(url, {
		method: "PUT",
		body: JSON.stringify(jsonData),
		signal,
	});

	return response;
};

export const getPendingTasks = async (
	assignee,
	pageNumber = 1,
	recordsByPage = 10,
	searchParam = "",
	startDate = "",
	endDate = "",
	sortField = "created_at",
	sortDirection = "desc",
	unassignedOnly = false,
	candidateGroups = null,
	includeFormData = true,
	signal = null // ✅ Add signal parameter with default null
) => {
	const url = `${GetPendingTasksEndPoint}/${assignee}`;

	const JsonBody = {
		"pageNumber": pageNumber,
		"recordsByPage": recordsByPage,
		"searchParam": searchParam,
		"startDateTime": startDate,
		"endDateTime": endDate,
		"lang": i18next.language,
		"sortField": sortField,
		"sortDirection": sortDirection,
		"candidateGroups": candidateGroups,
		"unassignedOnly": unassignedOnly,
		"includeFormData": includeFormData
	};

	const result = await makeAuthenticatedRequest(
		url,
		{
			method: "POST",
			body: JSON.stringify(JsonBody),
			signal, // ✅ Pass signal to fetch (can be null, that's fine)
		}
	);

	return result;
};

export const unclaimPendingTask = async (taskID, userID, signal = null) => {
	const url = `${UnclaimTaskEndPoint}/${taskID}/${userID}`;

	const response = await makeAuthenticatedRequest(url, {
		method: "POST",
		signal,
	});

	return response;
};

export const claimTask = async (taskID, userID, signal = null) => {
	var endpoint = `${ClaimTaskEndPoint}/${taskID}/${userID}`;

	const response = await makeAuthenticatedRequest(endpoint, {
		method: "POST",
		signal,
	});

	return response;
};

export const startWorkflowProcess = async (definitionKey, assignee, signal = null) => {
	var endpoint = `${StartProcessEndPoint}/${definitionKey}/${assignee}`;

	const response = await makeAuthenticatedRequest(endpoint, {
		method: "POST",
		signal,
	});
	let form_by_task_response = response.data.getCurrentUserTaskResponse.getFormByTaskResponse;
	const taskID = form_by_task_response.taskId;
	const processInstanceId = form_by_task_response.processInstanceId;
	const formPageNumber = form_by_task_response.formPageNumber;
	let startingPage = -1;
	const taskKey = response.data.getCurrentUserTaskResponse?.taskDefinitionKey;
	if (taskKey) {
			const parts = taskKey.split("-");
			startingPage = parts.length >= 3 ? parts[2] : parts[1] ?? -1;
		}
		//console.log("test"+form_by_task_response.key);
		let getEndPointResponse = null;

		if (formPageNumber === null || formPageNumber === undefined) {
			getEndPointResponse = await getFormByID(form_by_task_response.key);
		} else {
			getEndPointResponse = await getFormByID({
				form_key: form_by_task_response.key,
				pageNumber: formPageNumber,
				formData: {},
				readonly: false,
				startingPage: startingPage,
				dataReadOnly: false,
				hideSubmitButton: null
			});
		}

		var assignee = null;

		const formData = {
			...getEndPointResponse,
			taskID,
			processInstanceId,
			assignee,
		};
	response.data.formData=formData
    return response;
};
